export default {
    computed: {
        parentPageTitle() {
            if (this.$route.query.category) {
                return this.$route.query.category;
            } else {
                console.error('queryString에 category 값이 없습니다.');
                return '';
            }
        }
    },
}